import { render, staticRenderFns } from "./TelInputCustom.vue?vue&type=template&id=0b04ae82"
import script from "./TelInputCustom.vue?vue&type=script&lang=js"
export * from "./TelInputCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports